import { render, staticRenderFns } from "./AlterarSenhaPIN.vue?vue&type=template&id=9ff9f2f2"
import script from "./AlterarSenhaPIN.vue?vue&type=script&lang=ts"
export * from "./AlterarSenhaPIN.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports